import React from 'react';
import { Users, UserCheck, Clock, Archive } from 'lucide-react';
import { Badge } from '../ui/badge';
import { Card, CardContent } from '../ui/card';
import { Progress } from '../ui/progress';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../ui/accordion';

const EmployeeStatsAccordion = ({
  totalAll,
  activeCountAll,
  suspendedCountAll,
  inactiveCountAll,
  archivedCountAll,
  selectedDepartement,
  t,
}) => (
  <Accordion type="single" collapsible className="w-full">
    <AccordionItem value="stats">
      <AccordionTrigger>
        <div className="flex items-center space-x-2">
          <Users className="h-4 w-4" />
          <span>{t('employeesPage.sections.statistics')}</span>
          {selectedDepartement && (
            <Badge variant="outline" className="ml-2">{selectedDepartement.name}</Badge>
          )}
        </div>
      </AccordionTrigger>
      <AccordionContent>
        <div className="grid gap-4 md:grid-cols-5 pt-4">
          <Card>
            <CardContent className="p-6">
              <div className="flex items-center space-x-2">
                <Users className="h-4 w-4 text-muted-foreground" />
                <div>
                  <p className="text-xs font-medium text-muted-foreground">
                    {t('employeesPage.stats.totalEmployees')}{selectedDepartement ? ` (${selectedDepartement.name})` : ''}
                  </p>
                  <p className="text-2xl font-bold">{totalAll}</p>
                </div>
              </div>
            </CardContent>
          </Card>
          <Card>
            <CardContent className="p-6">
              <div className="flex items-center space-x-2">
                <UserCheck className="h-4 w-4 text-green-600" />
                <div>
                  <p className="text-xs font-medium text-muted-foreground">{t('employeesPage.stats.active')}</p>
                  <p className="text-2xl font-bold text-green-600">{activeCountAll}</p>
                  <Progress value={totalAll > 0 ? (activeCountAll / totalAll) * 100 : 0} className="mt-2 h-1" />
                </div>
              </div>
            </CardContent>
          </Card>
          <Card>
            <CardContent className="p-6">
              <div className="flex items-center space-x-2">
                <Clock className="h-4 w-4 text-amber-600" />
                <div>
                  <p className="text-xs font-medium text-muted-foreground">{t('employeesPage.stats.suspended')}</p>
                  <p className="text-2xl font-bold text-amber-600">{suspendedCountAll}</p>
                  <Progress value={totalAll > 0 ? (suspendedCountAll / totalAll) * 100 : 0} className="mt-2 h-1" />
                </div>
              </div>
            </CardContent>
          </Card>
          <Card>
            <CardContent className="p-6">
              <div className="flex items-center space-x-2">
                <Clock className="h-4 w-4 text-orange-600" />
                <div>
                  <p className="text-xs font-medium text-muted-foreground">{t('employeesPage.stats.inactive')}</p>
                  <p className="text-2xl font-bold text-orange-600">{inactiveCountAll}</p>
                  <Progress value={totalAll > 0 ? (inactiveCountAll / totalAll) * 100 : 0} className="mt-2 h-1" />
                </div>
              </div>
            </CardContent>
          </Card>
          <Card>
            <CardContent className="p-6">
              <div className="flex items-center space-x-2">
                <Archive className="h-4 w-4 text-muted-foreground" />
                <div>
                  <p className="text-xs font-medium text-muted-foreground">{t('employeesPage.stats.archived')}</p>
                  <p className="text-2xl font-bold text-muted-foreground">{archivedCountAll}</p>
                  <Progress value={totalAll > 0 ? (archivedCountAll / totalAll) * 100 : 0} className="mt-2 h-1" />
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
      </AccordionContent>
    </AccordionItem>
  </Accordion>
);

export default EmployeeStatsAccordion;
